import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserDoctor,
  faLaptopMedical,
  faHandHoldingHeart,
  faShieldHeart,
} from "@fortawesome/free-solid-svg-icons";

const features = [
  {
    icon: faUserDoctor,
    title: "Expert Care",
    description: "Board-certified psychiatric nurse practitioners",
  },
  {
    icon: faLaptopMedical,
    title: "Telehealth Convenience",
    description: "Quality care from the comfort of your home",
  },
  {
    icon: faHandHoldingHeart,
    title: "Compassionate Approach",
    description: "Safe, non-judgmental space for healing",
  },
  {
    icon: faShieldHeart,
    title: "Evidence-Based",
    description: "Proven treatment methods and best practices",
  },
];

const Welcome = () => {
  return (
    <div className="bg-gradient-to-b from-neutral-50 to-white py-16 md:py-24 lg:py-28">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-primary-100 rounded-full mb-6">
            <span className="text-primary-700 font-semibold text-body-sm">
              Welcome to Blissful Days
            </span>
          </div>
          <h1 className="text-heading-xl md:text-display-sm lg:text-display-md text-neutral-900 mb-6">
            Your Path to Mental Wellness
          </h1>
          <p className="text-body-lg md:text-heading-sm text-neutral-600 leading-relaxed max-w-3xl mx-auto">
            At Blissful Days Psychiatric Services, we believe in fostering mental
            wellness through compassionate care and evidence-based treatment. Our
            telehealth-based practice provides high-quality psychiatric services
            for individuals aged 18 and above in Maryland, Washington D.C., and
            Virginia.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl p-6 shadow-soft hover:shadow-medium transition-all duration-300 text-center"
            >
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-500 transition-colors">
                <FontAwesomeIcon
                  icon={feature.icon}
                  className="text-2xl text-primary-600 group-hover:text-white transition-colors"
                />
              </div>
              <h3 className="text-heading-sm text-neutral-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-body-md text-neutral-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Welcome;
